<template>
	<div>
		<xcategary></xcategary>
	</div>
</template>
<script>
	import xheader from "../../component/xheader.vue";
	import xfooter from "../../component/xfooter.vue";
	import xcategary from "../../component/xcategary.vue";
	
	export default{
		 components:{
		 	   xheader,
		 	   xfooter,
		 	   xcategary,
		 }
	}
</script>



// WEBPACK FOOTER //
// psort.vue?14a7c5f0